import FiltersSection from './FiltersSection';

export default FiltersSection;
